import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";

export default function ResumeViewModal({ show, onHide, data }) {
  if (!data) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      {/* HEADER */}
      <div style={header}>
        <h5>Resume Details</h5>
        <div onClick={onHide} style={closeBtn}>
          <FiX />
        </div>
      </div>

      {/* BODY */}
      <Modal.Body>
        <div>
          <h6>{data.name}</h6>
          <p>{data.email}</p>
          <p><b>Role:</b> {data.role}</p>
          <p><b>Experience:</b> {data.exp}</p>
          <p><b>Location:</b> {data.location}</p>
        </div>
      </Modal.Body>

      {/* FOOTER */}
      <div style={footer}>
        <Button onClick={onHide}>Close</Button>
      </div>
    </Modal>
  );
}

/* STYLES */
const header = {
  display: "flex",
  justifyContent: "space-between",
  padding: 15,
  borderBottom: "1px solid #eee",
};
const closeBtn = {
  cursor: "pointer",
  background: "#eee",
  borderRadius: "50%",
  padding: 5,
};
const footer = {
  padding: 15,
  borderTop: "1px solid #eee",
  textAlign: "right",
};